var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isActiveNewLocationModalVisible,
          expression: "isActiveNewLocationModalVisible"
        }
      ]
    },
    [
      _c("transition", { attrs: { name: "slide" } }, [
        _c("div", { staticClass: "modal-mask" }, [
          _c(
            "div",
            { staticClass: "modal-dialog modal-dialog-slideout modal-lg" },
            [
              _c("div", { staticClass: "modal-content p-2" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("div", { staticClass: "active-location-wrapper" }, [
                    _c(
                      "a",
                      {
                        staticClass: "text-uppercase text-muted pt-1",
                        attrs: { href: "javascript:void(0);" },
                        on: { click: _vm.hide }
                      },
                      [
                        _c("img", {
                          staticClass: "back_icon mr-2",
                          attrs: {
                            src: require("@/assets/manager/back_button_icon.png")
                          }
                        }),
                        _vm._v("Back")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "close float-right",
                        attrs: { type: "button" },
                        on: { click: _vm.hide }
                      },
                      [
                        _c("span", { attrs: { "aria-hidden": "true" } }, [
                          _vm._v("×")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "row mb-4" }, [
                    _c("div", { staticClass: "col-9 pl-3" }, [
                      _c(
                        "div",
                        { staticClass: "h3 d-inline mr-2 text-uppercase" },
                        [_vm._v("Add New Location")]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c("div", { staticClass: "successPanel" }, [
                        _c("div", { staticClass: "success_col_1" }, [
                          _c("p", { staticClass: "success-msg" }, [
                            _vm._v("Success!")
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "success-note" }, [
                            _c("i", { staticClass: "fa fa-check-circle-o" }),
                            _vm._v(
                              "Account Created\n                                        "
                            )
                          ]),
                          _vm._v(" "),
                          _vm.page_from_purchasing
                            ? _c("p", { staticClass: "success-note" }, [
                                _c("i", {
                                  staticClass: "fa fa-check-circle-o"
                                }),
                                _vm._v(
                                  "Purchase Confirmed\n                                        "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.invoice_filename
                            ? _c(
                                "div",
                                { staticClass: "success_col_3 text-left" },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "linkable",
                                      on: {
                                        click: function($event) {
                                          return _vm.openReceipt(
                                            _vm.invoice_filename
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(" View Receipt ")]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.total
                            ? _c(
                                "div",
                                { staticClass: "success_col_3 card-text" },
                                [
                                  _vm._v(
                                    "\n                                            Your card ending " +
                                      _vm._s(_vm.cc4_digit) +
                                      " was charged $" +
                                      _vm._s(_vm.total) +
                                      "\n                                        "
                                  )
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "success_col_2" }, [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/enterprise/Required_Rocket_Image_106x101.png"),
                              width: "70"
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row list_row_margin" }, [
                    _c("div", { staticClass: "col-12 text-center" }, [
                      _c("p", { staticClass: "font-weight-bold" }, [
                        _vm._v("What Happens Now?")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12" }, [
                      _c("ul", { staticClass: "list_items" }, [
                        _c("li", [
                          _vm._v(
                            "Primary admin creates password via system email"
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", [_vm._v("Primary admin (or you) adds users")]),
                        _vm._v(" "),
                        _c("li", [
                          _vm._v(
                            "Users complete required assessments, forms, and/or courses"
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _vm._v("Training and progress tracking begins!")
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row gotoBtn justify-content-md-center" },
                    [
                      _c("div", { staticClass: "col-6" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-sm btn-blue saveBtn text-center",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.openSidebar(_vm.accountId)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.goToBtnText))]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row mt-4 justify-content-md-center" },
                    [
                      _c("div", { staticClass: "col-6" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-sm btn-blue closeBtn text-center",
                            attrs: { type: "button" },
                            on: { click: _vm.closeModal }
                          },
                          [_vm._v("Close Window")]
                        )
                      ])
                    ]
                  )
                ])
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("EnterpriseAdminOverlaySidebar", {
        ref: "location_sidebar",
        attrs: { isModalVisible: _vm.isModalVisible, readOnly: "" },
        on: { close: _vm.closeSidebar }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b97ecda", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b97ecda","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/enterpriseadmin/active_new_location_modal.vue
// module id = null
// module chunks = 